<template>
    <div>
        <v-card outlined v-if="show == 'pc'">
            <v-carousel
                :continuous="true"
                :cycle="cycle"
                :show-arrows="false"
                :height="xheight != '' ? xheight : 200"
                delimiter-icon="mdi-minus"
            >
                <v-carousel-item v-for="(items1, i) in data1" :key="i">
                    <v-sheet
                        :height="xheight != '' ? xheight : 200"
                        class="pt-3 pb-3"
                        :color="colors[i % 2]"
                    >
                        <v-card-title class="headline pl-12 pr-12">
                            <span class="white--text">{{ items1.title }}</span>
                        </v-card-title>
                        <v-card-subtitle class="subtitle-2 pl-12 pr-12">
                            <span class="white--text">{{
                                items1.created_name +
                                    " - " +
                                    items1.created_date
                            }}</span>
                        </v-card-subtitle>
                        <hr />
                        <v-card-text
                            class="white--text pl-12 pr-12 pt-10"
                            v-html="items1.content"
                        ></v-card-text>
                    </v-sheet>
                </v-carousel-item>
            </v-carousel>
        </v-card>
        <v-card outlined v-else>
            <v-carousel
                :continuous="true"
                :cycle="cycle"
                :show-arrows="false"
                :height="xheight != '' ? xheight : 300"
                delimiter-icon="mdi-minus"
            >
                <v-carousel-item v-for="(items1, i) in data1" :key="i">
                    <v-sheet
                        :height="xheight != '' ? xheight : 300"
                        class="pt-3 pb-3"
                        :color="colors[i % 2]"
                    >
                        <v-card-subtitle class="headline pl-6 pr-6">
                            <span class="white--text">
                                {{ items1.title }}
                            </span>
                        </v-card-subtitle>
                        <hr />
                        <v-card-text
                            class="white--text pl-6 pr-6  "
                            v-html="items1.content"
                        ></v-card-text>
                    </v-sheet>
                </v-carousel-item>
            </v-carousel>
        </v-card>
    </div>
</template>
<script>
import axios from "axios"
export default {
    props: ["xheight", "show"],
    mounted() {
        this.getAjax1()
    },
    data() {
        return {
            data1: [],
            colors: ["#78adcf", "#6cb2ba"],
            cycle: true,
        }
    },
    methods: {
        async getAjax1() {
            const options = {
                headers: {
                    Authorization: "Bearer ",
                },
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/announce-active`
            await axios
                .get(url, options)
                .then((response) => {
                    response.data.map((each) => {
                        this.data1.push(Object.assign({}, each, {}))
                    })
                })
                .catch((error) => {
                    console.log(error)
                    return false
                })
        },
    },
}
</script>

<style scoped>
.image {
    display: none;
}
.fix-color-font {
    color: #fff !important;
}
</style>
